import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class User extends Model {
  resource() {
    return 'admin/reports'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }

  get incidentAddedDate() {
    return dayjs
      .utc(this.reportable.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }

  get fullName() {
    return this.reporter.full_name
  }

  get reportAsAnonymous() {
    return Boolean(this.report_as_anonymous)
  }
}
